import { Box, Paper, Skeleton, Stack } from '@mui/material';
import { memo } from 'react';

export const NotificationSkeleton = memo(function NotificationSkeleton() {
  return (
    <Stack spacing={1.5}>
      {Array.from({ length: 6 }).map((_, index) => (
        <Paper key={index} variant="outlined" sx={{ p: 2 }}>
          <Stack spacing={1}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Skeleton width="35%" height={22} />
              <Skeleton width={90} height={28} />
            </Box>
            <Skeleton width="70%" height={20} />
            <Skeleton width="50%" height={16} />
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
});
